import { ScrollView, View } from 'react-native';
import { styles } from './SingleColumnToolOptions.styles';
import { ToolOptionsRendererProps } from '../../../BaseToolbar.types';
import { useToolOptionsRendererLogic } from '../ToolOptionsRenderer.logic';
import { ToolOptionsProps } from '../ToolOptionsRenderer.types';
import { observer } from 'mobx-react-lite';
import { SingleColumnToolOption } from './single-column-tool-option/SingleColumnToolOption';
import { useStore } from 'src/contexts/StoreContext';

export const SingleColumnToolOptions = observer((props: ToolOptionsRendererProps<ToolOptionsProps>) => {
  const { options, isActive, isPriceVisible } = props;
  const { i18n } = useStore();
  const { scrollViewRef, getScrollViewElementTestId, isOptionSelected, onPressAndSelectToolOption } =
    useToolOptionsRendererLogic(props as ToolOptionsRendererProps<ToolOptionsProps>);

  return (
    <ScrollView
      style={styles.scrollView}
      contentContainerStyle={styles.contentContainer}
      ref={scrollViewRef}
      showsVerticalScrollIndicator={true}
      persistentScrollbar={true}
    >
      {options.map((option: ToolOptionsProps, index: number) => {
        return (
          <View key={option.productOptionChoiceCode} testID={getScrollViewElementTestId(index)}>
            <SingleColumnToolOption
              index={index}
              isActive={isActive}
              isPriceVisible={isPriceVisible}
              optionCode={option.productOptionCode}
              onPress={async () => onPressAndSelectToolOption(option)}
              isSelected={isOptionSelected(option)}
              isDisabled={!option.enabled}
              previewImageUrl={option.previewImageUrl}
              title={i18n.t(option.titleKey)}
              price={option.price}
              description={i18n.t(option.descriptionKey)}
              hint={option.hint && i18n.t(option.hint)}
            />
          </View>
        );
      })}
    </ScrollView>
  );
});

SingleColumnToolOptions.displayName = 'SingleColumnToolOptions';
